// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"20ff437c","25":"848d55ce","498":"7dccfc9f","551":"77eb6f64","640":"afb8883a","965":"152e495c"}[chunkId] + ".chunk.js";
};